import { FormattedMessage } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";

import { Heading } from "../components";

import { SwitchYourSiteMessage } from "./components";
import { TeamworkCollectionLogo } from "./components/teamwork-collection-logo";

export const UpliftEligibleUser = () => (
    <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
        <Heading>
            <FormattedMessage
                id="signup.teamworkCollection.uplift.heading"
                defaultMessage="Switch your site to Teamwork Collection"
            />
        </Heading>
        <SiteActivation UpliftEligibleUser={<SwitchYourSiteMessage />} />
    </SignupBackgroundLayout>
);
